import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteRetainerPeriodMutation($input: DeleteRetainerPeriodInput!) {
		deleteRetainerPeriod(input: $input) {
			deletedRetainerPeriodId
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.projectId,
			connectionKeys: [
				{
					key: 'Project_retainerPeriods',
				},
			],
			pathToConnection: ['project', 'retainerPeriods'],
			deletedIDFieldName: 'deletedRetainerPeriodId',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Retainer period deleted');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
